import { apiClient } from './apiClient';

import type { ApiResponse } from '@/types/auth.types';
import type {
  DocumentListData,
  DocumentQueueData,
  DocumentQueueParams,
  HrDocument,
  PreviewUrlData,
} from '@/types/document.types';

export async function getDocumentQueue(params: DocumentQueueParams = {}): Promise<DocumentQueueData> {
  const searchParams = new URLSearchParams();

  if (params.status) searchParams.set('status', params.status);
  if (params.category) searchParams.set('category', params.category);
  if (params.from) searchParams.set('from', params.from);
  if (params.to) searchParams.set('to', params.to);
  if (params.hasFlags !== undefined) searchParams.set('hasFlags', String(params.hasFlags));
  if (params.page) searchParams.set('page', String(params.page));
  if (params.limit) searchParams.set('limit', String(params.limit));

  const query = searchParams.toString();
  const url = `/documents/queue${query ? `?${query}` : ''}`;

  const response = await apiClient.get<ApiResponse<DocumentQueueData>>(url);
  return response.data;
}

export async function getDocumentsForApplication(applicationId: string): Promise<HrDocument[]> {
  const response = await apiClient.get<ApiResponse<DocumentListData>>(`/documents/by-application/${applicationId}`);
  return response.data.items;
}

export async function getDocumentPreviewUrl(documentId: string): Promise<PreviewUrlData> {
  const response = await apiClient.get<ApiResponse<PreviewUrlData>>(`/documents/${documentId}/preview-url`);
  return response.data;
}

export async function verifyDocument(documentId: string): Promise<HrDocument> {
  const response = await apiClient.put<ApiResponse<HrDocument>>(`/documents/${documentId}/verify`, {});
  return response.data;
}

export async function rejectDocument(documentId: string, rejectionReason: string): Promise<HrDocument> {
  const response = await apiClient.put<ApiResponse<HrDocument>>(`/documents/${documentId}/reject`, { rejectionReason });
  return response.data;
}

export async function requestReupload(documentId: string, reason: string): Promise<HrDocument> {
  const response = await apiClient.post<ApiResponse<HrDocument>>(`/documents/${documentId}/reupload-request`, {
    reason,
  });
  return response.data;
}

export async function getDocument(documentId: string): Promise<HrDocument> {
  const response = await apiClient.get<ApiResponse<HrDocument>>(`/documents/${documentId}`);
  return response.data;
}
